<template>
  <div class="add-engine">
    <div class="d-flex justify-content-between align-items-center">
      <h2 class="title">Edit Engine</h2>
      <div class="ico" @click="$emit('closeMe')">
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M19 6.41L17.59 5L12 10.59L6.41 5L5 6.41L10.59 12L5 17.59L6.41 19L12 13.41L17.59 19L19 17.59L13.41 12L19 6.41Z"
            fill="#474D52"
          />
        </svg>
      </div>
    </div>
    <p>What needs to be done to make this happen?</p>
    <textarea v-model="newEngine.title"></textarea>
    <div class="weeks">
      <div
        class="week"
        v-for="(day, k) in weeks"
        :key="k"
        :class="[activeArray.includes(day) ? 'active' : '']"
        @click="toggle(day, k)"
      >
        {{ day }}
      </div>
    </div>
    <div class="d-flex justify-content-between">
      <div class="time">
        <span @click="show.timeSelector = !show.timeSelector">
          {{ compHours + ":" + compMins + " " + newEngine.period }}
          <div class="ico">
            <svg
              width="7"
              height="5"
              viewBox="0 0 7 5"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M1 1L3.5 4L6 1"
                stroke="#5B606C"
                stroke-linecap="round"
              />
            </svg>
          </div>
        </span>

        <div class="time-selector" v-if="show.timeSelector">
          <div class="time-input">
            {{ compHours + ":" + compMins + " " + newEngine.period }}
          </div>
          <div class="select__time">
            <div class="wraper__time">
              <span
                class="ico ico-up"
                @click="newEngine.hour < 12 ? newEngine.hour++ : ''"
              >
                <svg
                  width="14"
                  height="8"
                  viewBox="0 0 14 8"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M6.29289 0.292893C6.68342 -0.0976311 7.31658 -0.0976311 7.70711 0.292893L13.7071 6.29289C14.0976 6.68342 14.0976 7.31658 13.7071 7.70711C13.3166 8.09763 12.6834 8.09763 12.2929 7.70711L7 2.41421L1.70711 7.70711C1.31658 8.09763 0.683417 8.09763 0.292893 7.70711C-0.0976311 7.31658 -0.0976311 6.68342 0.292893 6.29289L6.29289 0.292893Z"
                    fill="#474D52"
                  />
                </svg>
              </span>
              <span class="time-digit">
                <input
                  type="number"
                  min="01"
                  max="12"
                  value="12"
                  v-model="newEngine.hour"
                />
              </span>
              <span
                class="ico ico-down"
                @click="newEngine.hour > 1 ? newEngine.hour-- : ''"
              >
                <svg
                  width="14"
                  height="8"
                  viewBox="0 0 14 8"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M0.292893 0.292893C0.683417 -0.0976311 1.31658 -0.0976311 1.70711 0.292893L7 5.58579L12.2929 0.292893C12.6834 -0.0976311 13.3166 -0.0976311 13.7071 0.292893C14.0976 0.683417 14.0976 1.31658 13.7071 1.70711L7.70711 7.70711C7.31658 8.09763 6.68342 8.09763 6.29289 7.70711L0.292893 1.70711C-0.0976311 1.31658 -0.0976311 0.683417 0.292893 0.292893Z"
                    fill="#474D52"
                  />
                </svg>
              </span>
            </div>
            <div class="ico ico-colon">
              <svg
                width="8"
                height="32"
                viewBox="0 0 8 32"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M4 8C6.20914 8 8 6.20914 8 4C8 1.79086 6.20914 0 4 0C1.79086 0 0 1.79086 0 4C0 6.20914 1.79086 8 4 8Z"
                  fill="#474D52"
                />
                <path
                  d="M4 32C6.20914 32 8 30.2091 8 28C8 25.7909 6.20914 24 4 24C1.79086 24 0 25.7909 0 28C0 30.2091 1.79086 32 4 32Z"
                  fill="#474D52"
                />
              </svg>
            </div>
            <div class="wraper__time">
              <span
                class="ico ico-up"
                @click="newEngine.mins < 60 ? newEngine.mins++ : ''"
              >
                <svg
                  width="14"
                  height="8"
                  viewBox="0 0 14 8"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M6.29289 0.292893C6.68342 -0.0976311 7.31658 -0.0976311 7.70711 0.292893L13.7071 6.29289C14.0976 6.68342 14.0976 7.31658 13.7071 7.70711C13.3166 8.09763 12.6834 8.09763 12.2929 7.70711L7 2.41421L1.70711 7.70711C1.31658 8.09763 0.683417 8.09763 0.292893 7.70711C-0.0976311 7.31658 -0.0976311 6.68342 0.292893 6.29289L6.29289 0.292893Z"
                    fill="#474D52"
                  />
                </svg>
              </span>
              <span class="time-digit">
                <input
                  type="number"
                  min="00"
                  max="60"
                  value="00"
                  v-model="newEngine.mins"
                />
              </span>
              <span
                class="ico ico-down"
                @click="newEngine.mins > 0 ? newEngine.mins-- : ''"
              >
                <svg
                  width="14"
                  height="8"
                  viewBox="0 0 14 8"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M0.292893 0.292893C0.683417 -0.0976311 1.31658 -0.0976311 1.70711 0.292893L7 5.58579L12.2929 0.292893C12.6834 -0.0976311 13.3166 -0.0976311 13.7071 0.292893C14.0976 0.683417 14.0976 1.31658 13.7071 1.70711L7.70711 7.70711C7.31658 8.09763 6.68342 8.09763 6.29289 7.70711L0.292893 1.70711C-0.0976311 1.31658 -0.0976311 0.683417 0.292893 0.292893Z"
                    fill="#474D52"
                  />
                </svg>
              </span>
            </div>
            <div class="wraper__time">
              <span class="ico ico-up" @click="newEngine.period = 'AM'">
                <svg
                  width="14"
                  height="8"
                  viewBox="0 0 14 8"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M6.29289 0.292893C6.68342 -0.0976311 7.31658 -0.0976311 7.70711 0.292893L13.7071 6.29289C14.0976 6.68342 14.0976 7.31658 13.7071 7.70711C13.3166 8.09763 12.6834 8.09763 12.2929 7.70711L7 2.41421L1.70711 7.70711C1.31658 8.09763 0.683417 8.09763 0.292893 7.70711C-0.0976311 7.31658 -0.0976311 6.68342 0.292893 6.29289L6.29289 0.292893Z"
                    fill="#474D52"
                  />
                </svg>
              </span>
              <span class="time-digit">
                {{ newEngine.period }}
              </span>
              <span class="ico ico-down" @click="newEngine.period = 'PM'">
                <svg
                  width="14"
                  height="8"
                  viewBox="0 0 14 8"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M0.292893 0.292893C0.683417 -0.0976311 1.31658 -0.0976311 1.70711 0.292893L7 5.58579L12.2929 0.292893C12.6834 -0.0976311 13.3166 -0.0976311 13.7071 0.292893C14.0976 0.683417 14.0976 1.31658 13.7071 1.70711L7.70711 7.70711C7.31658 8.09763 6.68342 8.09763 6.29289 7.70711L0.292893 1.70711C-0.0976311 1.31658 -0.0976311 0.683417 0.292893 0.292893Z"
                    fill="#474D52"
                  />
                </svg>
              </span>
            </div>
          </div>
        </div>
      </div>
      <div class="ico" @click="$bvModal.show('calendar-modal')">
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M2.8125 1.875H3.9375V0H5.8125V1.875H18.1875V0H20.0625V1.875H21.1875C22.7383 1.875 24 3.13669 24 4.6875V21.1875C24 22.7383 22.7383 24 21.1875 24H2.8125C1.26169 24 0 22.7383 0 21.1875V4.6875C0 3.13669 1.26169 1.875 2.8125 1.875ZM1.875 21.1875C1.875 21.7044 2.29556 22.125 2.8125 22.125H21.1875C21.7044 22.125 22.125 21.7044 22.125 21.1875V8.8125H1.875V21.1875ZM1.875 6.9375H22.125V4.6875C22.125 4.17056 21.7044 3.75 21.1875 3.75H20.0625V5.625H18.1875V3.75H5.8125V5.625H3.9375V3.75H2.8125C2.29556 3.75 1.875 4.17056 1.875 4.6875V6.9375Z"
            fill="#CBCBCB"
          />
          <path
            d="M18.5625 10.7812H20.4375V12.6562H18.5625V10.7812Z"
            fill="#CBCBCB"
          />
          <path
            d="M14.8125 10.7812H16.6875V12.6562H14.8125V10.7812Z"
            fill="#CBCBCB"
          />
          <path
            d="M11.0625 10.7812H12.9375V12.6562H11.0625V10.7812Z"
            fill="#CBCBCB"
          />
          <path
            d="M7.3125 10.7812H9.1875V12.6562H7.3125V10.7812Z"
            fill="#CBCBCB"
          />
          <path
            d="M3.5625 10.7812H5.4375V12.6562H3.5625V10.7812Z"
            fill="#CBCBCB"
          />
          <path
            d="M18.5625 14.5312H20.4375V16.4062H18.5625V14.5312Z"
            fill="#CBCBCB"
          />
          <path
            d="M14.8125 14.5312H16.6875V16.4062H14.8125V14.5312Z"
            fill="#CBCBCB"
          />
          <path
            d="M11.0625 14.5312H12.9375V16.4062H11.0625V14.5312Z"
            fill="#CBCBCB"
          />
          <path
            d="M7.3125 14.5312H9.1875V16.4062H7.3125V14.5312Z"
            fill="#CBCBCB"
          />
          <path
            d="M18.5625 18.2812H20.4375V20.1562H18.5625V18.2812Z"
            fill="#CBCBCB"
          />
          <path
            d="M14.8125 18.2812H16.6875V20.1562H14.8125V18.2812Z"
            fill="#CBCBCB"
          />
          <path
            d="M11.0625 18.2812H12.9375V20.1562H11.0625V18.2812Z"
            fill="#CBCBCB"
          />
          <path
            d="M7.3125 18.2812H9.1875V20.1562H7.3125V18.2812Z"
            fill="#CBCBCB"
          />
          <path
            d="M3.5625 14.5312H5.4375V16.4062H3.5625V14.5312Z"
            fill="#CBCBCB"
          />
        </svg>
      </div>
    </div>
    <button
      class="btn btn-primary btn-sm collapsed"
      @click="addEngine"
      v-if="!editMode"
    >
      Add
    </button>
    <button
      v-else
      class="btn btn-primary btn-sm collapsed"
      @click="updateEngine"
    >
      Update
    </button>
    <calendar></calendar>
  </div>
</template>

<script>
import Calendar from "@/components/common/calendar";
export default {
  props: ["engine", "editMode"],
  data() {
    return {
      weeks: ["Su", "M", "Tu", "W", "Th", "F", "Sa"],
      activeArray: ["Su"],
      newEngine: {
        title: "",
        hour: "12",
        mins: "0",
        period: "AM"
      },
      show: {
        timeSelector: false,
        calendar: true
      }
    };
  },
  components: {
    Calendar
  },
  mounted() {
    if (this.editMode) {
      this.editDate();
    }
  },
  methods: {
    addEngine() {
      this.$emit("add-engine", {
        text: this.newEngine.title,
        time:
          this.compHours + ":" + this.compMins + " " + this.newEngine.period,
        when: this.activeArray
      });
      this.show.timeSelector = false;
      this.newEngine.title = "";
      this.activeArray = [];
      this.newEngine.hour = "12";
      this.newEngine.mins = "0";
      this.newEngine.period = "AM";
    },
    updateEngine() {
      this.$emit("update-engine", {
        ...this.engine,
        text: this.newEngine.title,
        time:
          this.compHours + ":" + this.compMins + " " + this.newEngine.period,
        when: this.activeArray
      });
      this.show.timeSelector = false;
      this.newEngine.title = "";
      this.activeArray = [];
      this.newEngine.hour = "12";
      this.newEngine.mins = "0";
      this.newEngine.period = "AM";
    },
    toggle(day, i) {
      let index = this.activeArray.indexOf(day);
      if (index > -1) {
        this.activeArray.splice(index, 1);
      } else {
        this.activeArray.push(day);
      }
    },
    editDate() {
      this.newEngine.title = this.engine.text;
      this.newEngine.hour = this.engine.time.split(":")[0];
      this.newEngine.mins = this.engine.time.split(":")[1].split(" ")[0];
      this.newEngine.period = this.engine.time.split(":")[1].split(" ")[1];
      this.activeArray = this.engine.when;
      console.log(this.newEngine);
      //   this.editIndex = index;
      //   this.active = "edit";
    }
  },
  computed: {
    // filteredEngines() {
    //   if (this.searchStr.trim() == "") return this.engines;

    //   return this.engines.filter((cr) => {
    //     return cr.title
    //       .toLowerCase()
    //       .includes(this.searchStr.toLowerCase().trim());
    //   });
    // },
    compHours() {
      if (this.newEngine.hour < 10) {
        if (this.newEngine.hour == "0" || this.newEngine.hour[0] != "0")
          return "0" + this.newEngine.hour;
        else {
          return this.newEngine.hour;
        }
      }
      return this.newEngine.hour;
    },
    compMins() {
      if (this.newEngine.mins == "0" || this.newEngine.mins[0] != "0")
        return "0" + this.newEngine.mins;
      else {
        return this.newEngine.mins;
      }
    }
  }
};
</script>

<style scoped lang="scss">
.btn.collapsed {
  padding: 11px;
  width: 100%;
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  line-height: 22px;
  color: #ffffff;
  border-radius: 8px;
  margin-top: 23px;
}
.add-engine {
  padding: 24px;
  position: relative;
  .title {
    font-style: normal;
    font-weight: bold;
    font-size: 16px;
    line-height: 22px;
    color: #474d52;
    margin: 0;
  }
  p {
    margin-top: 24px;
    font-style: normal;
    font-weight: normal;
    font-size: 16px;
    line-height: 22px;

    /* Body */

    color: #474d52;
    margin-bottom: 16px;
  }
}
textarea {
  resize: none;
  border: none;
  outline: none;
  width: 100%;
  height: 90px;
  background: #ffffff;
  box-shadow: 2px 2px 40px rgba(33, 24, 86, 0.03);
  border-radius: 8px;
  //   padding: 12px;

  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  line-height: 22px;
  color: #474d52;
  margin-bottom: 24px;
}
.weeks {
  //   display: flex;
  // justify-content: space-around;
  //   align-items: center;
}
.weeks .week {
  display: inline-block;
  width: 30.87px;
  height: 30.87px;
  margin: 8px 0px;
  text-align: center;
  background-color: red;
  color: #557efb;
  font-style: normal;
  font-weight: 300;
  font-size: 12px;
  line-height: 30.87px;
  text-align: center;
  background-color: rgba(85, 126, 251, 0.1);
  margin-right: 4px;
  font-style: normal;
  font-weight: 300;
  font-size: 13.5936px;
  text-align: center;
  border-radius: 50%;
  cursor: pointer;

  /* Secondary */

  color: #8d99a0;
}
.weeks .week.active {
  color: #fff;
  background-color: #557efb;
}

// ......
//  .selections {
//     display: flex;
//     justify-content: space-between;
//     align-items: center;
//     margin-top: 40px;
.time {
  background-color: #f3f6f9;
  width: 108px;
  border-radius: 10px;
  font-style: normal;
  font-weight: normal;
  font-size: 12px;
  line-height: 16px;
  text-align: center;
  height: 28px;
  display: flex;
  justify-content: center;
  align-items: center;
  color: #5b606c;
  position: relative;
  transition: all 0.2s ease-in-out;
  svg {
    //  fill: ;
  }
  &:hover,
  &:active {
    background: #557efb;
    span {
      color: #fff;
      fill: #fff !important;
    }
  }
  & > span {
    cursor: pointer;
    width: 100%;
    display: flex;
    justify-content: space-evenly;
    // align-items: center;
    align-items: center;
  }
  .time-selector {
    position: absolute;
    top: 100%;
    left: 0%;
    background-color: #fff;
    box-shadow: 0px 4px 12px rgba(0, 0, 0, 0.08);
    border-radius: 8px;
    padding: 8px;
    * {
      user-select: none; /* standard syntax */
      -webkit-user-select: none; /* webkit (safari, chrome) browsers */
      -moz-user-select: none; /* mozilla browsers */
      -khtml-user-select: none; /* webkit (konqueror) browsers */
      -ms-user-select: none; /* IE10+ */
    }
    .time-input {
      // input {
      background: #ffffff;
      border-radius: 32px;
      border: 1px solid #ddd;
      display: flex;
      justify-content: center;
      align-items: center;
      padding: 7px;
      margin: 4px 0;
      h5 {
        font-family: "Nunito", sans-serif;
        font-style: normal;
        font-weight: normal;
        font-size: 12px;
        line-height: 16px;
        text-align: center;
        color: #474d52;
        margin: 0;
      }
      // }
    }
    .select__time {
      display: flex;
      justify-content: center;
      align-items: center;
    }
    .wraper__time {
      display: flex;
      justify-content: center;
      align-items: center;
      flex-direction: column;
      border: 1px solid #dddddd;
      box-sizing: border-box;
      border-radius: 4px;
      margin: 0px 3px;
      span {
        height: 30px;
        width: 45px;
        position: relative;
        display: flex;
        justify-content: center;
        align-items: center;
        &.ico-up {
          &:after {
            content: "";
            width: 90%;
            left: 50%;
            transform: translateX(-50%);
            bottom: 0;
            position: absolute;
            border-bottom: 1px solid #dddddd;
          }
        }
        &.ico-down {
          &:after {
            content: "";
            width: 90%;
            left: 50%;
            transform: translateX(-50%);
            top: 0;
            position: absolute;
            border-bottom: 1px solid #dddddd;
          }
        }
        &.time-digit {
          height: 33px;
          color: #474d52 !important;
          input {
            border: none;
            text-align: center;
            &:focus {
              outline: none;
            }
          }
          input::-webkit-outer-spin-button,
          input::-webkit-inner-spin-button {
            -webkit-appearance: none;
            margin: 0;
          }

          /* Firefox */
          input[type="number"] {
            -moz-appearance: textfield;
          }
        }
      }
    }
  }
}
.days {
  display: flex;
  justify-content: space-between;
  align-items: center;
  .day,
  .now {
    width: 50px;
    height: 29px;
    background: #f3f6f9;
    border-radius: 1000px;
    font-style: normal;
    font-weight: 300;
    font-size: 12px;
    line-height: 16px;
    text-align: center;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #8d99a0;
    cursor: pointer;
    margin: 0 2px;
    transition: all 0.2s ease-in-out;
    &:hover,
    &.active {
      background: #557efb;
      color: #fff;
    }
  }
  .day {
    width: 29px;
    height: 29px;
    border-radius: 50%;
  }
}
//   }
</style>
